import { createAction } from '@reduxjs/toolkit';

export const clearLocalStorageSelection = createAction('dataAnalyzer/clearLocalStorageSelection', (
  sessionId?: string,
) => ({
  payload: {
    sessionId,
  },
}));
